// extracted by mini-css-extract-plugin
export default {"stepWrapper":"CalculatorBody_stepWrapper__78nD8"};